import React from "react";
import Router from "./routes/router";

import "./App.css";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { ToastContainer } from "react-toastify";

// Create a custom theme
const theme = createTheme({
  overrides: {
    MuiTablePagination: {
      spacer: {
        flex: "1 1",
      },
    },
  },
  typography: {
    fontFamily: ["Roboto"].join(","),
  },
});
export default () => (
  <React.Fragment>
    <ThemeProvider theme={theme}>
      <Router />
      <ToastContainer limit={2} newestOnTop={false} />
    </ThemeProvider>
  </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/App.js